import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import {
  TimesheetResponse,
  TimesheetReview,
  TimesheetUpdateResponse,
} from '@interfaces/vendor-management-model';
import { GlobalErrorService } from '@services/global-error.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TimesheetService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
  ) {}

  getContractorsTimesheet(
    employeeId: string,
    month: number,
    year: number,
    params: {
      vendor?: string;
      status?: string;
      location?: string;
      dntLeader?: string;
      employeeStatus?: string;
      filterType?: string;
    } = {},
  ): Observable<TimesheetResponse> {
    const url = `${this.baseUrl}/hiring/timesheet`;
    const { vendor, status, location, dntLeader, employeeStatus, filterType } =
      params;
    const payload = {
      employeeId: employeeId || '',
      status: status !== undefined ? status : null,
      month: month || null,
      year: year || null,
      location: location || null,
      vendor: vendor || null,
      dntLeaderName: dntLeader || null,
      employeeStatus: employeeStatus || null,
      filterType: filterType || null,
    };

    return this.http.post<TimesheetResponse>(url, payload).pipe(
      catchError((error) => {
        return this.errorHandler.logError(error);
      }),
    );
  }

  updateTimesheetStatus(
    timesheetData: TimesheetReview,
  ): Observable<TimesheetUpdateResponse> {
    const url = `${this.baseUrl}/hiring/timesheet`;
    return this.http.put<TimesheetUpdateResponse>(url, timesheetData).pipe(
      catchError((error) => {
        return this.errorHandler.logError(error);
      }),
    );
  }
}
